module.exports = __webpack_public_path__ + "img/pc_p3_yun.b8574b4b.svg";